"use client";
import "keen-slider/keen-slider.min.css"
import {useKeenSlider} from "keen-slider/react";
import ActivityCard from "@/components/ActivitiesNew/ActivityCard";
export default function ActivitiesSlider({activities}){
    const animation = { duration: 100000, easing: (t) => t }
    const [sliderRef] = useKeenSlider({
        loop: true,
        renderMode: "performance",
        drag: false,
        slides : {perView: 1, spacing: 10},
        breakpoints : {
          '(min-width: 600px)' : {
              slides : {perView : 2, spacing : 100}
          },
          '(min-width: 1000px)' : {
              slides : {perView : 3, spacing : 120}
          },
          '(min-width: 1400px)' : {
              slides : {perView : 4, spacing : 120}
          }
        },
        created(s) {
            s.moveToIdx(5, true, animation)
        },
        updated(s) {
            s.moveToIdx(s.track.details.abs + 5, true, animation)
        },
        animationEnded(s) {
            s.moveToIdx(s.track.details.abs + 5, true, animation)
        },
    });

    return(
        <div ref={sliderRef} className={"keen-slider max-w-full"}>
            {activities.map(function(activity){
                return(
                    <ActivityCard
                        key={activity.id}
                        short_details={activity.short_details}
                        date_event={activity.date_event}
                        id={activity.id}
                        title={activity.title}
                        type={activity.type}
                        address={activity.address}
                        img={activity.documents.length > 0 ? activity.documents[0] : false}
                        participant_count={activity.participants_count}
                        place_max={activity.place_max}
                        price={activity.price}
                        slug={activity.slug}
                        status={activity.status}
                        user={activity.user}
                        participants={activity.participants_with_code}
                        isSlide={true}
                    />
                )
            })}
        </div>
    )
}